import {Component} from '@angular/core';
import {WidgetInputDirective} from '../../directives/widget-input.directive';

@Component({
  selector: 'pt-widget-preliminary-risk-assessment',
  template: `
    <div
      class='widget-border'
      data-testid="widget-preliminary-risk-assessment"
      id='widget_{{initializationWidget.internalId}}'
      [ngSwitch]='initializationWidget?.version'>

      <pt-widget-preliminary-risk-assessment-v0
        *ngSwitchCase='0'
        [lockAcquired]='lockAcquired'
        [initializationWidget]='initializationWidget'
        [status]='status'>
      </pt-widget-preliminary-risk-assessment-v0>

      <pt-widget-version-missing
        *ngSwitchDefault
        [type]='initializationWidget?.type'
        [label]='initializationWidget?.label'
        [version]='initializationWidget?.version'>
      </pt-widget-version-missing>

    </div>
  `
})
export class WidgetPreliminaryRiskAssessmentComponent extends WidgetInputDirective {
}
